<template>

    <div v-if="active">
        <button class="btn btn-default btn-xs pull-right" type="button"
            :disabled="posting"
            @click="toggle"
            v-tooltip="'Deze gebruiker deactiveren'"
        ><i class="mdi mdi-toggle-switch"></i></button>
        <span>Ja</span>
    </div>
    <div v-else>
        <button class="btn btn-default btn-xs pull-right" type="button"
            :disabled="posting"
            @click="toggle"
            v-tooltip="'Deze gebruiker activeren'"
        ><i class="mdi mdi-toggle-switch-off-outline"></i></button>
        <span>Nee</span>
    </div>

</template>

<script>

import axios from 'axios';

export default {

    data() {
        return {
            active:false,
            posting:false,
        }
    },

    methods: {

        toggle() {
            if (this.posting === true || (this.active === true && !confirm("Weet je zeker dat deze gebruiker gedeactiveerd moet worden? Alle toegewezen licenties zullen worden vrijgegeven!"))) {
                return false;
            }
            this.posting = true;
            axios.patch(this.toggleUrl)
            .then(resp => {
                console.log(resp);
                this.active = resp.data.data.newstatus;
                this.$snotify.success("Deze gebruiker is ge" + (this.active === false ? 'de' : '') + "activeerd.");
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het in-/uitschakelen van deze gebruiker"))
            .finally(() => this.posting = false);
        },

    },

    mounted() {
        if (this.currentActive === true) {
            this.active = true;
        }
    },

    name:"UsersToggleActive",

    props: {
        currentActive: {
            required:true,
        },
        toggleUrl: {
            required:true,
        },
    }

}

</script>
